import type { IconSvgObject } from './types';

const GalleryHorizontalEndIcon: IconSvgObject = [
  ["path", { d: "M11 18V6C11 4.89543 11.8954 4 13 4H19C20.1046 4 21 4.89543 21 6V18C21 19.1046 20.1046 20 19 20H13C11.8954 20 11 19.1046 11 18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 6V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 8V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default GalleryHorizontalEndIcon;
